'use client';

import { SectionStack } from '@/components/ui/SectionStack';
import { Calculator } from './Calculator';
import { Hero } from './Hero';

const AnnualOverpaymentsClient = () => (
  <SectionStack>
    <div className="container mx-auto">
      <Hero />
    </div>
    <Calculator />
  </SectionStack>
);

export default AnnualOverpaymentsClient;
